import React, { Component } from 'react'

import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter,  MDBBreadcrumb, MDBBreadcrumbItem } from 'mdbreact';
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBMask, MDBView, MDBJumbotron, MDBBox } from 'mdbreact';
import { MDBTable, MDBTableBody, MDBTableHead,  } from 'mdbreact';
import { Form, Input, Button, Checkbox, message } from 'antd';
//import Login from './Login';
import Axios from 'axios'
import { URL } from '../../api';
import logo from '../img/logokpru.png'
import FadeIn from 'react-fade-in';
import p1 from '../img/1656587759_2-illustration_png.png'
import p2 from '../img/1656587759_4-illustration_png.png'
import p3 from '../img/1656587761_12-illustration_png.png'
import Iframe from 'react-iframe'
import { api } from '../../api';

import { HorizontalBar } from 'react-chartjs-2';


import Swal from 'sweetalert2'
import {
  MDBTypography,
  MDBCard,
  MDBCardBody,
  MDBCardImage,
  MDBCardTitle,
  MDBCardText
} from 'mdbreact';

var xlsx = require("xlsx");


export default class Publicresearch extends Component {


  constructor(props) {
    super(props);
    this.state = {
      value: '',
      Psaaword: '',
      modal: false,
      collapse: false,
      isWideEnough: false,
      datastuKamphaengphet:[],
      team: '2565',

    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChange2 = this.handleChange2.bind(this);
    this.toggle = this.toggle.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onClick2 = this.onClick2.bind(this);
    this.readUploadFile = this.readUploadFile.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);


  }

  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
//https://research.kpru.ac.th/research_new/Administrator_ResearchPublish/getpublic
    for (let index = 0; index < this.state.datastuKamphaengphet.length; index++) {

      const datafrm = new FormData(); 
      datafrm.append("ResearchID", this.state.datastuKamphaengphet[index].ResearchID);
      datafrm.append("ResearchName", this.state.datastuKamphaengphet[index].ResearchName);
      datafrm.append("Year", this.state.datastuKamphaengphet[index].Year);
      datafrm.append("Yr", this.state.datastuKamphaengphet[index].Yr);
      datafrm.append("FieldName", this.state.datastuKamphaengphet[index].FieldName);
      datafrm.append("research_concerned", this.state.datastuKamphaengphet[index].research_concerned);
      datafrm.append("Programe", this.state.datastuKamphaengphet[index].Programe);
      datafrm.append("faculty", this.state.datastuKamphaengphet[index].faculty);
   

          api.post("index/Addresearch/",datafrm,{
              headers: {
                  'content-type': 'multipart/form-data'
              }
            })

            
          .then(res => {
                if (res.status === 200) {
                 
                      if (this.state.datastuKamphaengphet.length === index+1) {
                        
                          Swal.fire({
                                title: 'นำเข้าข้อมูลสำเร็จ',
                                icon: 'success',
                              // showCancelButton: true,
                                confirmButtonText: 'ตกลง',
                              // cancelButtonText: 'No, keep it'
                              }).then((result) => {
                              
                              })
                      }
                }
          })   
  }

        
  }


  componentDidMount() {

    // fetch('https://portal.bopp-obec.info/obec64/restpublicstat/download/area/2564-2-schoolmis-00620001.json', {
    //     method: 'GET',
    //     body: JSON.stringify(),
    //     headers: {
    //     }
    //   })
    //     .then(res => res.json())
    //     .then((res) => {
    //         this.setState({ datastuKamphaengphet: res })
    //     })
    //     .catch(err => {
    //       console.log('request failed', err);
    //     })


    Axios.get('https://research.kpru.ac.th/Api_Research/index/research_fordashboard')
    .then((res) => {
         console.log(res.data.data)
       this.setState({ datastuKamphaengphet: res.data.data})
    })


  }

 onClick2() {
     console.log('dd')
          Axios.get('https://portal.bopp-obec.info/obec64/restpublicstat/download/area/2564-2-schoolmis-00620001.json')
         .then((res) => {
      //  console.log(res.data)
       
        this.setState({ datastuKamphaengphet: res })
    })

  }



  onClick() {
    this.setState({
      collapse: !this.state.collapse,
    });
  }


  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  }

  handleChange(event) { this.setState({ value: event.target.value }); }
  handleChange2(event) { this.setState({ Psaaword: event.target.value }); }


  update = () => {
    this.setState({
      name: "",
      lname: ""
    })
  }

  readUploadFile = (e) => {
    e.preventDefault();
    if (e.target.files) {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = e.target.result;
            const workbook = xlsx.read(data, { type: "array" });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const json = xlsx.utils.sheet_to_json(worksheet);
         //   console.log(json);
            this.setState({ datastuKamphaengphet: json })

        };
        reader.readAsArrayBuffer(e.target.files[0]);
    }
}


  render() {
    const dUrl = "https://portal.bopp-obec.info/obec64/restpublicstat/download/area/2564-2-schoolmis-00620001.json";

  // console.log(dUrl);
   console.log(this.props.location.pathname )
 //console.log('dd')

    return (

      <MDBContainer fluid>
       
        <MDBRow >
          <MDBCol md="12">
            <div>
              {/* <img src="https://research.kpru.ac.th/culture/LogoRDI.png" className="rounded mx-auto d-block w-50" alt="aligment" /><br/> */}
              {/* <img src={logo} className="rounded mx-auto d-block w-10 " alt="aligment" /><br/> */}
              <FadeIn>
              <MDBJumbotron className="p-4" fluid >
                 
                <MDBTypography blockquote bqColor='primary' className='h-0'>
                  <MDBIcon icon="user-injured" />   นำเข้าข้อมูลผลงานวิจัย
                </MDBTypography>
                {/* <MDBTypography note noteColor='primary' noteTitle='ด้านนักศึกษา '> </MDBTypography> */}
                    <MDBBreadcrumb>
                        <MDBBreadcrumbItem>Home</MDBBreadcrumbItem>
                        <MDBBreadcrumbItem>สำหรับ Admin</MDBBreadcrumbItem>
                        <MDBBreadcrumbItem active>นำเข้าข้อมูลผลงานวิจัย</MDBBreadcrumbItem>
                    </MDBBreadcrumb>
             
                            <br/>
                           

                            <form>
    <label htmlFor="upload">Upload File</label><br/>
    <input
        type="file"
        name="upload"
        id="upload"
        onChange={this.readUploadFile}
    />
</form>
<br/>


{this.state.datastuKamphaengphet.length !== 0 ?<>
<p>ตัวอย่างข้อมูล {this.state.datastuKamphaengphet.length} รายการ</p>
  <MDBTable small style={{ border: "1px" }} border width="100%">
                            <MDBTableHead  >
                                <tr  >
                                    <th>ลำดับ</th>
                                    <th>รหัส</th>
                                    <th>ชื่องานวิจัย</th>
                                    <th>ปีที่เสร็จ</th>
                                    <th>ปีที่เริ่ม</th>
                                    <th>สาขาวิจัย</th>
                                    <th>สอดคล้อง</th>
                                    <th>สาขาวิชา</th>
                                    <th>คณะ</th>
                                   
                                   
                                </tr>
                            </MDBTableHead>


                            <MDBTableBody>
                                {this.state.datastuKamphaengphet.map((data,index) => {
                                    return <tr>
                                        <td>{index+1} </td>
                                        <td>{data.ResearchID}</td>
                                        <td>{data.ResearchName}</td>
                                        <td>{data.Year}</td>
                                        <td>{data.Yr}</td>
                                        <td>{data.FieldName}</td>
                                        <td>{data.research_concerned}</td>
                                        <td>{data.Programe}</td>
                                        <td>{data.faculty}</td>
                                       
                                      
                                    </tr>
                                })}
                            </MDBTableBody>
                        </MDBTable>
<div  className='text-center'>
     <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn>
</div>
                     
</>:<>

</>}
                          

<br/>
       
                ที่มา 
                <MDBIcon icon="caret-left" /><a href='https://www.sesaokpp.go.th/cms-sesaokpp/'> บัณฑิต</a>
                    {/* <MDBIcon icon="caret-left" /><a href='https://portal.bopp-obec.info/obec64/publicstat/report'> ระบบสารสนเทศ สพม</a> */}
                {/* <MDBIcon icon="caret-left" /><a href='/'> จำนวนนักเรียนมัธยมแต่ละโรงเรียน</a>
               <div > <MDBIcon icon="caret-left"  /> จำนวนผู้เข้าชม</div> */}
              </MDBJumbotron>

       

              </FadeIn>
            </div>
          </MDBCol>
        </MDBRow>

      </MDBContainer>


    )
  }
}
